import {Injectable} from '@angular/core';
import {OpenSpaceService} from "src/app/services/open-space.service";
import {
    MatSnackBar,
    MatSnackBarModule,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import {OpenSpace} from "src/app/entities/openSpace";
import {Subscription} from 'rxjs';
import {StorageMap} from '@ngx-pwa/local-storage';


const OK_MESSAGE = 'OK';
const CONVERT_TO_HOURS = 60 * 60;

@Injectable({
    providedIn: 'root'
})
export class NotifierService {

    constructor(private _snackBar: MatSnackBar,
                private openService: OpenSpaceService,
                private storage: StorageMap) {
    }


    openSpace: OpenSpace;
    openSpaceId: number;
    dataSubscription: Subscription;
    today: any;
    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    todayMessageVote: string = 'Hoy es el último día para votar, tienes hasta las ';
    todayMessagePropose: string = 'Hoy es el último día para proponer, tienes hasta las ';
    tomorrowMessageVote: string = 'Mañana es el último día para votar. ';
    tomorrowMessagePropose: string = 'Mañana es el último día para proponer. ';
    warningMessage: string = "";
    showWarning: boolean = false;
    deadLineTimeToVote: number;
    deadLineTimeToPropose: number;


    displaySnackbar(displayMessage, buttonAction, duration?: number, hp?: string, vp?: string) {
        this._snackBar.open(displayMessage, buttonAction, {
            duration: 60000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['snackbar']
        });
    }

    deadLineNotifications(openSpace: OpenSpace) {
        this.today = new Date();
        const zone = this.today.toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2];

        // Calcula los días entre current date y fin votación / propuestas
        const remainingHoursToVote = openSpace.remainingVotingSeconds / CONVERT_TO_HOURS;
        const remainingHoursToPropose = openSpace.remainingProposingSeconds / CONVERT_TO_HOURS;
        this.warningMessage = "";


        if (remainingHoursToVote > 0) {
            this.deadLineTimeToVote = this.today.getHours() + remainingHoursToVote;
            if (this.deadLineTimeToVote < 24) {
                this.showWarning = true;
                this.warningMessage = this.todayMessageVote + Math.trunc(this.deadLineTimeToVote) + `:59:59 ` + zone + '. ';
            } else if (this.deadLineTimeToVote < 48) {
                this.showWarning = true;
                this.warningMessage = this.tomorrowMessageVote;
            }
        }

        if (remainingHoursToPropose > 0) {
            this.deadLineTimeToPropose = this.today.getHours() + remainingHoursToPropose;

            if (this.deadLineTimeToPropose < 24) {
                this.showWarning = true;
                this.warningMessage = (this.warningMessage + '\n' + this.todayMessagePropose + Math.trunc(this.deadLineTimeToPropose) + `:59:59 ` + zone + '. ').trim();
            } else if (this.deadLineTimeToPropose < 48) {
                this.showWarning = true;
                this.warningMessage = (this.warningMessage + '\n' +  this.tomorrowMessagePropose).trim();
            }
        }

        if (this.showWarning) {
            this.displaySnackbar(this.warningMessage, OK_MESSAGE);
            this.showWarning = false;
        }

    }
}
